export default "__VITE_ASSET__f58ad18a__"